<template lang="pug">
div
  form(@submit.prevent)
    h3 {{$t('Поиск входящей транзакции')}} (ETH, USDT, TRX)
    .input-grid
      label Tx hash
      input(v-model="tx").form-control
      button(type="button" @click="makeDirty" :disabled="isSubmitDisabled").btn-success.btn
        template(v-if="!dirty") {{$t('Искать')}}
        template(v-if="dirty") {{$t('Идет поиск...')}}
      template(v-if="model.errors.has()")
        div
        error-message-block(attribute="*|tx" :errors="model.errors")
        div
      template(v-if="txResult")
        div
        div
          span.help-block
            strong {{$t('Результат:')}}
            | &nbsp;&nbsp;
            span {{ $t('searchStatus.' + txResult.state) }}
        div

</template>

<script lang="ts">
import {Component, Vue, Watch} from "vue-property-decorator";
import {TxSearchModel, TxSearchResult} from "@/views/pages/finance/tools/txsearch";
import debounce from '@/polyfill/Debounce';
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";

@Component({
  name: "EthTransactionSearch",
  components: {ErrorMessageBlock}
})
export default class EthTransactionSearch extends Vue {
  tx = ''
  model = new TxSearchModel()
  debouncedSearch = null
  dirtyIndex = 0
  dirty = false
  dirtyTx = ''
  txResult: TxSearchResult = null

  created() {
    this.debouncedSearch = debounce(this.search as any, 500);
  }

  @Watch('tx')
  onTxUpdate() {
    this.makeDirty();
  }

  get isSubmitDisabled() {
    return String(this.tx).trim().length == 0;
  }

  makeDirty() {
    if (this.dirty && (this.dirtyTx === this.tx))
      return;

    const dirtyIndex = ++this.dirtyIndex;
    this.txResult = null;
    this.dirtyTx = this.tx;
    if (String(this.tx).trim().length == 0)
    {
      this.dirty = false;
      this.model.errors.clear();
      return;
    }
    this.dirty = true;
    this.model.errors.clear();
    this.debouncedSearch(this.tx, dirtyIndex);
  }

  search(tx: string, dirtyIndex: number) {
    return this.model.search(tx).then((txresult: TxSearchResult) => {
      if (dirtyIndex === this.dirtyIndex)
      {
        this.dirty = false;
        this.txResult = txresult;
      }
    }).catch(err => {
      if (dirtyIndex === this.dirtyIndex)
      {
        this.dirty = false;
        this.txResult = null;
        this.model.checkAxiosError(err);
      }
      throw err;
    });
  }

}
</script>

<style scoped lang="less">
.input-grid {
  display: grid;
  grid-template-columns: auto 1fr max-content;
  grid-gap: 5px 20px;
  align-items: center;
  label {
    margin: 0;
    font-weight: normal;
  }
  .form-control, .btn {
    height: 42px;
  }
}
h3 {
  margin: 0 0 15px 0;
  font-size: 110%;
  font-weight: bold;
}
</style>

<i18n>
{
  "en": {
    "Поиск входящей транзакции": "Search incoming transaction",
    "Искать": "Search",
    "Идет поиск...": "Searching in progress...",
    "searchStatus": {
      "found": "Transaction Found. Please wait for execution.",
      "notfound": "Transaction not found.",
      "executed": "Deposit payment successfully executed.",
      "planned": "Transaction Found. Please wait for execution."
    },
    "Результат:": "Result:"
  },
  "ru": {
    "searchStatus": {
      "found": "Транзакция найдена. Ожидайте обработки и зачисления.",
      "notfound": "Транзакция не найдена.",
      "executed": "Входящий платеж успешно зачислен.",
      "planned": "Транзакция найдена. Ожидайте обработки и зачисления."
    }
  }
}
</i18n>
